import { Box, BoxProps } from "@hightouch/htui";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.108 5.629c-.567-1.692 1.193-3.185 2.768-2.425l14.496 7.004.136.072c1.364.786 1.319 2.809-.136 3.512L5.876 20.796c-1.574.76-3.335-.732-2.768-2.424l2.085-6.213a.5.5 0 0 0 0-.318L3.108 5.629Zm3.798 5.03A.5.5 0 0 0 7.38 11h1.918a1 1 0 0 1 0 2H7.38a.5.5 0 0 0-.474.34l-1.52 4.526a.5.5 0 0 0 .692.61l12.473-6.026a.5.5 0 0 0 0-.9L6.08 5.522a.5.5 0 0 0-.691.61l1.518 4.527Z"
      clipRule="evenodd"
    />
  </Box>
);
